import {
    SET_OUT_REFILLS,
    UPDATE_OUT_REFILLS,
    CLEAR_OUT_REFILLS,
} from '../ActionTypes/ActionTypes';

const initialState = {
    refills: [
        {
            id: 1,
            order_identifier: '45-1',
            delivery_date: '2019-01-10',
            order_id: 45,
            order_status: 'Confirmed',
            status: 1,
            start_date: '2019-01-11',
            end_date: '2019-01-30',
            packaging_date: '2019-01-10',
            mobile_number: '9650384701',
            is_vip: true,
            contact_number: '9650384701',
            address: 'B1-H4, Mohan Estate, 110044',
            patient_name: 'Vishal Gupta',
            location: 'Opal Caredose',
            next_start_date: '2019-01-31',
        },
    ],
};

const DispatchReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_OUT_REFILLS:
        return {
            ...state,
            refills: action.payload.data,
        };

    case UPDATE_OUT_REFILLS:
        console.log(action);
        state.refills.splice(action.payload.id, 1, action.payload.data);
        return {
            ...state,
        };

    case CLEAR_OUT_REFILLS:
        return {
            ...state,
            refills: [],
        };

    default:
        return state;
    }
};


export default DispatchReducer;



// WEBPACK FOOTER //
// ./src/Reducer/DispatchReducer.js